module.exports = __webpack_public_path__ + "static/img/can-apple.02c6f60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-apple.png
// module id = X9vI
// module chunks = 0